import configService from './configService';
import parameterService from './parameterService';
import translations from '../data/translations';

const LANGUAGE_PARAM_NAME = 'language';

class LanguageService {
    constructor() {
        this.translations = translations;

        this.languageFromQuery = this.getQueryVariable(LANGUAGE_PARAM_NAME);
        this.onChangeFuncs = [];

        // backup translations
        this.selected = parameterService.language || 'en';
        this.texts = this.translations[this.selected];

        // load translations from templates folder
        try {
            configService.getTranslations(data => {
                if (!data instanceof Array) {
                    return;
                }
                this.translations = data;
                this.select(parameterService.language);
            });
        } catch(err) {}
    }

    getAvailable() {
        let keys = Object.keys(this.translations);
        return keys.map(key => {
            return {
                code: key,
                name: this.translations[key].name
            };
        });
    }

    getQueryVariable(variable) {
        let query = window.location.search.substring(1);
        let vars = query.split("&");
        for (let i=0;i<vars.length;i++) {
            let pair = vars[i].split("=");
            if (pair[0] === variable) {
                return pair[1];
            }
        }
        return false;
    }

    select(language) {
        if (this.languageFromQuery) {
            language = this.languageFromQuery;
        }

        if (!(this.translations[language] instanceof Object)) {
            language = 'en';
        }

        this.texts = this.translations[language];
        this.selected = language;
        this.onChangeFuncs.forEach(func => func());
    }

    onChange(func) {
        this.onChangeFuncs.push(func);
    }

    translate(name, replacements) {
        let text = this.texts[name];

        if (text && replacements) {
            text = text.replace(/%(\w+)%/g, function(full, group) {
                return replacements[group] || group;
            });
        }

        return text;
    }

    getFooter() {
        const {selected, translations} = this;
        const data = translations[selected];
        const footer = data && data.footer;


        return footer || {};
    }
}

export default new LanguageService();



// WEBPACK FOOTER //
// ./src/services/languageService.js